import React, { useEffect, useState } from "react";
import { getFAQs } from "./Helper";
import { CircularProgress } from "@mui/material";

export default function SharedFAQ({ section }) {
  const [faqs, setFAQs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    getFAQs(section)
      .then((res) => {
        setFAQs(res.data?.faq);
        setTimeout(() => {
          setIsLoading(!isLoading);
        }, 1000);
      })
      .catch((err) => console.log(err));
  }, [section]);
  return (
    <div class="max-w-screen-xl mx-auto px-5 bg-white min-h-sceen">
      <div class="flex flex-col items-center">
        <h2 class="font-bold text-5xl mt-5 tracking-tight text-[#2EBAA3]">
          FAQ
        </h2>
        <p class="text-neutral-500 text-xl mt-3">Frequenty asked questions</p>
      </div>
      {isLoading ? (
        <div class="flex flex-col items-center">
          <br />
          <br />
          <br />
          <CircularProgress />
        </div>
      ) : (
        <div class="grid divide-y divide-neutral-200 max-w-xl mx-auto mt-8">
          {faqs?.map((faq, index) => {
            return (
              <div class="py-5" key={faq?.id}>
                <details class="group">
                  <summary class="flex justify-between items-center font-medium cursor-pointer list-none">
                    <span style={{ userSelect: "none" }}>{faq?.title}</span>
                    <span class="transition group-open:rotate-180">
                      <svg
                        fill="none"
                        height="24"
                        shape-rendering="geometricPrecision"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        viewBox="0 0 24 24"
                        width="24"
                      >
                        <path d="M6 9l6 6 6-6"></path>
                      </svg>
                    </span>
                  </summary>
                  <p class="text-neutral-600 mt-3 group-open:animate-fadeIn" style={{ userSelect: "none" }}>
                    {faq?.description}
                  </p>
                </details>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
